<template>
  <!-- 取消/修改订单审核 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='cancelModifyOrderList-1'
          />
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <!-- 批量操作 -->
            <btns-operate
              :isBatch="true"
              :multipleSelection="multipleSelection"
              @success="getList"
            />
            <div style="margin-left: 10px" v-if="$has('FWS-KJSH-XGDDSH-DC')">
              <page-export-button
                title="数据导出"
                button-text="导出"
                exportServe="fin_receipt_orderUpdateReport"
                :total="total"
                :isLimit="true"
                :exportParams="exportParams"
                trackCode='cancelModifyOrderList-2'
              />
            </div>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          @selection-change="handleSelectionChange"
          ref="modifyOrderListRef"
        >
          <template v-slot:options="{row}">
            <btns-operate
              :current="row"
              @success="getList"
            />
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :apply-no.sync="applyNo"
      @operate-success="getList"
    />
  </div>
</template>

<script>
import { getOrderList } from '@/api/approval/order';
import detail from './components/detail';
import BtnsOperate from './components/btns-operate';
import { setStatusColor } from '@/filters/index';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchContent: '', // 搜索值
  searchType: '1',
  status: '', // 审核状态 1 待审核 2 已通过 -1 已驳回 -2 已取消 0 取消中
  applyType: '', // 申请类型1、取消 2、修改
  transType: 2, // 1自营 2服务商
  timeType: '1',
};

export default {
  name: 'CancelModifyOrderList',
  components: { detail, BtnsOperate },
  data() {
    return {
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
            { label: '审核时间', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [
            { value: '1', label: '申请编号' },
            { value: '2', label: '业务订单编号' },
            { value: '3', label: '客户名称' },
            { value: '4', label: '客户编号' },
          ],
        },
      ],
      isDetailShow: false, // 详情弹窗
      applyNo: '', // 申请编号
      multipleSelection: [], // 批量操作-选中的数据
      tableColumn: [
        {
          type: 'selection',
          width: '40',
          align: 'center',
          isShow: () => false,
          show: () => this.$has('FWS-KJSH-DDSK-TGBH'),
          selectable: (row) => this.setDisabled(row),
        },
        {
          prop: 'applyNo',
          label: '申请编号',
          minWidth: '1',
          disabled: true,
          trackCode: 'cancelModifyOrderList-3',
          click: (row) => this.handleDetail(row),
          show: () => this.$has('FWS-KJSH-DDSK-XQ'),
        },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1' },
        { prop: 'typeDesc', label: '申请类型', minWidth: '1' },
        { prop: 'businessName', label: '客户名称', minWidth: '1' },
        { prop: 'businessNo', label: '客户编号', minWidth: '1' },
        { prop: 'sourceDesc', label: '归属业务', minWidth: '1' },
        { prop: 'crtime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        {
          label: '审核状态',
          status: 'status',
          prop: 'status',
          statusDesc: 'statusDesc',
          disabled: true,
          statusColor: (val) => setStatusColor(val, 'approvalStatus'),
        },
        { prop: 'acceptUser', label: '操作人', minWidth: '1' },
        { prop: 'operate', slotName: 'options', label: '操作', width: '160', show: () => this.$has('FWS-KJSH-DDSK-TGBH'), disabled: true },
      ],
      selectTableColumn: [],
      recommendedColumn: [
        { prop: 'approvalTime', label: '审核时间', minWidth: '1', filterName: 'formatTime' },
        { prop: 'rejectReason', label: '驳回原因', minWidth: '1', showOverflowTooltip: true },
      ],
      columnsKey: 'fwsModifyOrderList',
      selectList: [
        {
          title: '审核状态',
          prop: 'status',
          dictionaryPath: '/finance/finance-receipt/OrderApprovalStatusEnum',
        },
        {
          title: '申请类型',
          prop: 'applyType',
          dictionaryPath: '/finance/finance-receipt/FinOrderUpdTypeEnum',
        },
      ],
    };
  },
  computed: {
    exportParams() {
      const params = {
        ...this.queryForm,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const { applyType, status } = this.$route.query;
      this.queryForm.applyType = applyType || '';
      this.queryForm.status = status || '';
      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.modifyOrderListRef.doLayout();
      });
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 列表接口请求
    async getList() {
      try {
        const param = { ...this.queryForm };
        this.loading = true;
        this.list = [];
        const res = await getOrderList(param);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.getList();
    },
    // 多选选择返回结果
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量确认多选限制设置
    setDisabled(row) {
      if ([1, '1'].includes(row.status)) {
        return 1;
      }
      return 0;
    },
    // 详情
    handleDetail(row) {
      this.applyNo = row?.applyNo || '';
      this.isDetailShow = true;
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
  },
};
</script>
